var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41667 0.25H17.5833C18.775 0.25 19.75 1.225 19.75 2.41667V17.5833C19.75 18.775 18.775 19.75 17.5833 19.75H2.41667C1.225 19.75 0.25 18.775 0.25 17.5833V2.41667C0.25 1.225 1.225 0.25 2.41667 0.25ZM4.58333 15.4167H12.1667V13.25H4.58333V15.4167ZM15.4167 11.0833H4.58333V8.91667H15.4167V11.0833ZM4.58333 6.75H15.4167V4.58333H4.58333V6.75Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list.6294ea6505b64d837ceaeeecbf71e186.svg";